import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';

/** Broadens a search to hopefully include more results */
export const extendSearch = (filters: FilterChoice): FilterChoice => ({
  ...filters,
  onlineAppointments: {},
});
